import * as React from 'react';
import { Button, ButtonProps, Text } from '@front10/base-elements';
import Box from '../elements/Box';
import Icon from '../elements/Icon';

type Props = {
  active?: boolean;
  layout?: 'compact' | 'standard' | 'closed';
  iconSettings?: $TSFixMe;
  iconLeftSettings?: $TSFixMe;
  count?: boolean;
  countValue?: number;
  labelSeparator?: string;
  onFocus?: any;
};

type FilterButtonProps = Pick<ButtonProps, 'onClick' | 'value' | 'type'> & Props;

export const FilterButton = React.forwardRef<HTMLButtonElement, FilterButtonProps>(
  function FilterButton(
    {
      active,
      value,
      type,
      iconSettings,
      iconLeftSettings,
      count,
      countValue,
      labelSeparator = ',',
      ...props
    }: FilterButtonProps,
    ref
  ) {
    const layout = props.layout ?? 'compact';
    const countValueCalc =
      typeof value === 'string' && count ? value.split(labelSeparator).length : 0;

    return (
      <Button
        ref={ref as any}
        variant={layout === 'closed' ? 'text.fontSize5' : 'filter'}
        type={type ?? 'button'}
        data-active={active ? '' : undefined}
        sx={{
          display: 'inline-flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...(layout === 'standard' && {
            variant: 'layout.layoutStyles',
            width: '100%'
          }),
          ...(layout === 'closed' && {
            variant: 'layout.inputStyles',
            cursor: 'pointer',
            pt: '4px',
            pb: '5px',
            px: '9px',
            bg: 'white',
            width: '100%',
            '&:focus': {
              outline: '0'
            }
          })
        }}
        {...props}
      >
        {iconLeftSettings && <Icon icon="sort" size={12} {...iconLeftSettings} />}
        <Text as="span">{value}</Text>
        {count && !countValue && countValueCalc > 1 && <Text as="p">({countValueCalc})</Text>}
        {count && countValue !== undefined && countValue > 1 && <Text as="p">({countValue})</Text>}
        <Box display="flex" ariaHidden={true}>
          <Icon
            marginLeft="2"
            marginTop="-4px"
            icon="keyboard_arrow_down"
            size={12}
            {...iconSettings}
          />
        </Box>
      </Button>
    );
  }
);
